module.exports = __webpack_public_path__ + "static/media/courses-bg.bc435adf.svg";